module.exports = __webpack_public_path__ + "img/志愿者.d63e2cbe.png";